import type { SVGProps } from "react";
const SvgIconCalendarCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M643.52 438.96 448.36 634.12l-67.88-67.88c-9.37-9.37-24.57-9.37-33.94 0s-9.37 24.57 0 33.94l84.85 84.85c4.5 4.5 10.61 7.03 16.97 7.03s12.47-2.53 16.97-7.03L677.46 472.9c9.37-9.37 9.37-24.57 0-33.94s-24.57-9.37-33.94 0" />
    <path d="M757 192h-43v-50c0-13.81-11.19-25-25-25s-25 11.19-25 25v50H360v-50c0-13.81-11.19-25-25-25s-25 11.19-25 25v50h-43c-41.35 0-75 33.65-75 75v490c0 41.36 33.65 75 75 75h490c41.36 0 75-33.64 75-75V267c0-41.35-33.64-75-75-75m0 590H267c-13.79 0-25-11.21-25-25V342h540v415c0 13.79-11.21 25-25 25" />
  </svg>
);
export default SvgIconCalendarCheck;
